import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function FooterSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full" data-id="element-9" data-mp="3h8902c42uldo">
      {/* SECTION 12 - CTA FINAL */}
      <section className="py-20 sm:py-24 bg-court-deep px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden" data-id="element-10" data-mp="3c9fv582uw2p4">
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-11" data-mp="2okwo0vvjlvym">
          <div className="flex items-center justify-center gap-2 mb-7" data-id="element-12" data-mp="2kirwq3skhbf5">
            <span className="text-lg" data-id="element-13" data-mp="2kgf6l3cnnur0">🎾</span>
            <span className="text-amber-300 font-heading font-bold text-sm tracking-[0.25em] uppercase" data-id="element-14" data-mp="2ya6fc9ikbalo">
              Class Room
            </span>
          </div>

          <h2 className="text-2xl sm:text-4xl md:text-5xl font-heading font-extrabold mb-7 text-white leading-tight" data-id="element-15" data-mp="2thdehwq7smev">
            El sistema de planificación N°1 para profesores de pádel.
          </h2>

          <p className="text-lg sm:text-2xl text-amber-300 font-heading font-bold mb-10 leading-snug" data-id="element-16" data-mp="1ggpyxvx4fqyt">
            "Porque preparar una buena clase no debería costarte todas las
            noches de la semana."
          </p>

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white text-base sm:text-xl font-heading font-extrabold py-5 px-10 rounded-2xl shadow-2xl shadow-orange-900/40 transition-all hover:scale-[1.03] flex items-center justify-center gap-3 uppercase tracking-wide mx-auto mb-9" data-id="element-17" data-mp="1q69h0zd0fgsm">
            💪 → QUIERO MI PADEL 360 AHORA
          </button>

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-blue-200 font-medium" data-id="element-18" data-mp="17egp789og1mh">
            <span className="flex items-center gap-2" data-id="element-19" data-mp="1bfaeo62rpohh">
              <ShieldCheck className="w-4 h-4" data-id="element-20" data-mp="2iuf4htvg7jw5" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-21" data-mp="2mw0kho3a4eak">
              <Lock className="w-4 h-4" data-id="element-22" data-mp="2mymwbzx7dfyl" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-23" data-mp="nqh54j6mtvwh">
              <CreditCard className="w-4 h-4" data-id="element-24" data-mp="itgxi3u4wl39" /> Tarjetas · Transferencia
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 13 - FOOTER */}
      <footer className="bg-slate-900 text-slate-400 py-12 px-4 sm:px-6 lg:px-8 text-center" data-id="element-25" data-mp="wqchgrbxbwy3">
        <div className="max-w-7xl mx-auto" data-id="element-26" data-mp="rrsuqopiah4o">
          <div className="text-lg font-heading font-extrabold text-white mb-6 tracking-tight" data-id="element-27" data-mp="439pki1r6kgt">
            🎾 CLASS ROOM · PADEL 360™
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-8 font-medium text-sm" data-id="element-28" data-mp="d2ae19q06j">
            <a href="#" className="hover:text-white transition-colors" data-id="element-29" data-mp="dvp4t7lo0uy0">
              📧 contacto@classroom.com
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-30" data-mp="3hio0cu0b7g49">
              📲 @classroom.padel
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-31" data-mp="3citcz0fqt8ny">
              🌐 www.classroom.com
            </a>
          </div>

          <p className="text-xs border-t border-slate-800 pt-8 max-w-2xl mx-auto leading-relaxed" data-id="element-32" data-mp="1rzpidtkcg4xs">
            © CLASS ROOM · PADEL 360™ 2024 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </footer>
    </div>;
}